import { LayerCollection } from '@datum-map';
import { MouseController } from './MouseController/MouseController';
import { INewsItemProperties } from './News/types';
import { IEventsItemProperties } from './EventsOpen/types';
import { SingleWindow } from './Window';
import { IUserLayerRecordProperties } from '@project/API/resources/userLayer';
import { LinkController } from './LinkController';
import { TableCardMouseControllerLink } from './MouseController/TableCardMouseControllerLink';
import {
  EventsCardMouseControllerLink,
  NewsCardMouseControllerLink,
} from './MouseController';
import { UserLayerCardMouseControllerLink } from './MouseController/UserLayerCardMouseControllerLink';

export class CardController {
  readonly recordCard: TableCardMouseControllerLink;
  readonly news: NewsCardMouseControllerLink;
  readonly events: EventsCardMouseControllerLink;
  readonly userLayer: UserLayerCardMouseControllerLink;

  constructor(
    private _mouseController: MouseController,
    private _linkController: LinkController,
    private _collection: LayerCollection,
    private _newsCard: SingleWindow<INewsItemProperties>,
    private _eventsCard: SingleWindow<IEventsItemProperties>,
    private _userLayerCard: SingleWindow<IUserLayerRecordProperties>,
  ) {
    this.recordCard = new TableCardMouseControllerLink(
      this._mouseController,
      this._linkController.card,
      this._collection,
    );

    this.news = new NewsCardMouseControllerLink(
      this._mouseController,
      this._newsCard,
    );

    this.events = new EventsCardMouseControllerLink(
      this._mouseController,
      this._eventsCard,
    );

    this.userLayer = new UserLayerCardMouseControllerLink(
      this._mouseController,
      this._userLayerCard,
    );
  }

  bind = () => {
    this.unbind();

    this.userLayer.bind();
    this.events.bind();
    this.news.bind();
    this.recordCard.bind();

    return this.unbind;
  };

  unbind = () => {
    this.userLayer.unbind();
    this.events.unbind();
    this.news.unbind();
    this.recordCard.unbind();
  };
}
